exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.email-box .el-input__suffix {\n  display: none;\n}\n.email-box .el-select {\n  width: 100%;\n}\n.is-multiple {\n  display: none;\n}\n", ""]);

// exports
